import { AxiosRequestConfig } from "axios";
import { httpService } from "./HttpServices";
import { ApiResponse } from "./UserService";

export interface StripeStatusData {
  connected: boolean;
  stripeAccountId?: string;
  stripePublishableKey?: string;
  livemode?: boolean;
  expiresAt?: string;
  isExpired?: boolean;
  needsReconnect?: boolean;
  createdAt?: string;
}

export interface StripeAuthorizationData {
  authorizationUrl: string;
}

export class StripeIntegrationService {
  async getStripeStatus(
    config?: AxiosRequestConfig
  ): Promise<{ data: StripeStatusData; message: string }> {
    try {
      const response = await httpService.get<ApiResponse<StripeStatusData>>(
        "/stripe/status",
        config
      );
      return {
        data: response.data,
        message: response.message,
      };
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message ||
        "Failed to fetch Stripe connection status.";
      throw new Error(errorMessage);
    }
  }

  async connectStripe(
    config?: AxiosRequestConfig
  ): Promise<{ data: StripeAuthorizationData; message: string }> {
    try {
      const response = await httpService.get<
        ApiResponse<StripeAuthorizationData>
      >("/stripe/connect", config);
      return {
        data: response.data,
        message: response.message,
      };
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || "Failed to connect Stripe.";
      throw new Error(errorMessage);
    }
  }

  async disconnectStripe(
    config?: AxiosRequestConfig
  ): Promise<{ data: {}; message: string }> {
    try {
      const response = await httpService.delete<ApiResponse<{}>>(
        "/stripe/disconnect",
        config
      );
      return {
        data: response.data,
        message: response.message,
      };
    } catch (error: any) {
      const errorMessage =
        error?.response?.data?.message || "Failed to disconnect Stripe.";
      throw new Error(errorMessage);
    }
  }
}

export const stripeIntegrationService = new StripeIntegrationService();
